const autoNgTemplateLoaderTemplate1 = require('./access-viewer-datatable.html');

import './access-viewer-datatable.css';

export const accessViewerDatatable = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    tableKey: '@',
    orderBy: '@',
    dataset: '<',
    isAdmin: '<',
  },
};
